module.exports = __webpack_public_path__ + "static/media/hidden.d3341a95.jpg";